import React from 'react';
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-400 py-16 border-t border-gray-900" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-131">
          <div className="col-span-1 lg:col-span-1" data-id="element-132">
            <span className="font-serif text-2xl font-semibold text-white tracking-tight block mb-2" data-id="element-133">
              Kareem Jamal
            </span>
            <span className="text-[10px] tracking-widest text-brand-gold uppercase font-medium block mb-6" data-id="element-134">
              Rodeo Realty Fine Estates
            </span>
            <p className="text-sm font-light leading-relaxed mb-6" data-id="element-135">
              Building generational wealth through strategic real estate
              investments in Chatsworth and beyond.
            </p>
            <div className="flex space-x-4" data-id="element-136">
              <a href="#" className="text-gray-500 hover:text-brand-gold transition-colors" data-id="element-137">
                <Instagram className="w-5 h-5" data-id="element-138" />
              </a>
              <a href="#" className="text-gray-500 hover:text-brand-gold transition-colors" data-id="element-139">
                <Facebook className="w-5 h-5" data-id="element-140" />
              </a>
              <a href="#" className="text-gray-500 hover:text-brand-gold transition-colors" data-id="element-141">
                <Linkedin className="w-5 h-5" data-id="element-142" />
              </a>
            </div>
          </div>

          <div data-id="element-143">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-144">
              Contact
            </h4>
            <ul className="space-y-4" data-id="element-145">
              <li className="flex flex-col space-y-2" data-id="element-146">
                <a href="tel:805-422-5488" className="flex items-center text-sm hover:text-brand-gold transition-colors" data-id="element-147">
                  <Phone className="w-4 h-4 mr-3" data-id="element-148" />
                  805-422-5488
                </a>
                <a href="tel:818-402-7326" className="flex items-center text-sm hover:text-brand-gold transition-colors" data-id="element-149">
                  <Phone className="w-4 h-4 mr-3 opacity-0" data-id="element-150" />
                  818-402-7326
                </a>
                <span className="text-xs text-gray-500 ml-7 italic" data-id="element-151">
                  For faster responses, please text. Otherwise call/email.
                </span>
              </li>
              <li data-id="element-152">
                <a href="mailto:Kareem@KareemJamalTheRealtor.com" className="flex items-center text-sm hover:text-brand-gold transition-colors" data-id="element-153">
                  <Mail className="w-4 h-4 mr-3" data-id="element-154" />
                  Kareem@KareemJamalTheRealtor.com
                </a>
              </li>
              <li className="flex items-start text-sm" data-id="element-155">
                <MapPin className="w-4 h-4 mr-3 mt-0.5 flex-shrink-0" data-id="element-156" />
                <span data-id="element-157">
                  Chatsworth, CA 91311
                  <br data-id="element-158" />
                  Serving Los Angeles County
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-159">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-160">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-161">
              <li data-id="element-162">
                <a href="#lead-form" className="text-sm hover:text-brand-gold transition-colors" data-id="element-163">
                  Home Valuation
                </a>
              </li>
              <li data-id="element-164">
                <a href="#market-stats" className="text-sm hover:text-brand-gold transition-colors" data-id="element-165">
                  91311 Market Stats
                </a>
              </li>
              <li data-id="element-166">
                <a href="#about" className="text-sm hover:text-brand-gold transition-colors" data-id="element-167">
                  About Kareem
                </a>
              </li>
              <li data-id="element-168">
                <a href="#" className="text-sm hover:text-brand-gold transition-colors" data-id="element-169">
                  Search Homes
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-170">
            <h4 className="text-white font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-171">
              Legal
            </h4>
            <p className="text-xs font-light leading-relaxed mb-4" data-id="element-172">
              Kareem Jamal | DRE #01998956 <br data-id="element-173" />
              Rodeo Realty, Inc. | DRE #00951359
            </p>
            <p className="text-xs font-light leading-relaxed" data-id="element-174">
              Information deemed reliable but not guaranteed. Equal Housing
              Opportunity.
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row justify-between items-center" data-id="element-175">
          <p className="text-xs font-light mb-4 md:mb-0" data-id="element-176">
            &copy; {new Date().getFullYear()} Kareem Jamal Real Estate. All
            rights reserved.
          </p>
          <div className="flex space-x-6 text-xs font-light" data-id="element-177">
            <a href="#" className="hover:text-white transition-colors" data-id="element-178">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-179">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}